import { TaskAssignee } from 'api/taskTypes';
import { getAssigneeInitials } from 'state/ProjectTasksList/bulkActions/bulkAssign/availableAssignees/utils';
import { isUserStatusDisabled } from 'utils/functions';

export const convertToOptions = (assignee: TaskAssignee, checked: boolean) => {
  const { name, id, avatarUrl, status } = assignee;

  return {
    label: name,
    value: id,
    avatar: {
      imageSrc: avatarUrl,
      name,
      initial: getAssigneeInitials(assignee),
      disabled: isUserStatusDisabled(status),
    },
    checked,
    disabled: isUserStatusDisabled(status),
  };
};
